<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import { VclList } from "vue-content-loading";

export default {
  locales: {
    pt: {
    },
    es: {
    },
  },
  components: {
    Layout,
    VclList
  },
  data() {
    return {
      loading: true,
      errored: false,

      plan: "all",
      regional: "team",
      NameFilter: "",

      total: 0,
      fields: [
        { key: "plan", label: "Tipo" },
        { key: "name", label: "Nome" },
        { key: "sponsor", label: "Patrocinador" },
        { key: "date", label: "Data" },
        { key: "level", label: "Nível" },
        { key: "apvs", label: "Última Adesão" },
        { key: "action", label: "" },
      ],
      items: null,

      sortBy: "name",
      sortDesc: false,
      currentPage: "1",
      perPage: "25",
      periodMonth: new Date(),
      filterBy: "",
      filterOn: [
        "name"
      ],
      filterOptions: {
        name: "Nome",
        date: "Data",
        level: "Nível",
      },

      totalUsers: 0,

      change: {
        modal: false,
        loading: false,
        step: 1,
        user: {
          id: "",
          name: "",
          person_number: "",
          sponsor: {
            id: "",
            name: "",
            person_number: "",
          },
        },
        search: {
          loading: false,
          q: "",
          results: null,
        },
        choosed: {
          id: "",
          name: "",
          person_number: "",
          sponsor: {
            id: "",
            name: "",
            person_number: "",
          },
        }
      },
    };
  },
  methods: {
    getList() {
      this.loading = true;
      this.errored = false;
      this.items = null;

      api
        .get("network/team?plan=" + this.plan + "&regional=" + this.regional + "&perPage=" + this.perPage + "&page=" + this.currentPage + "&searchname=" + this.NameFilter)
        .then((response) => {
          if (response.data.status == 'success') {
            this.items = response.data.list;
            this.totalUsers = response.data.total;
          }
        })
        .catch((error) => {
          this.errored = error;
        })
        .finally(() => {
          this.loading = false;
          if (this.body == "" || this.body == null) {
            this.empty = true;
          }
        });
    },
    showSponsor(user) {
      this.change.modal = false;
      this.change.modal = true;
      this.change.loading = false;
      this.change.step = 1;
      this.change.user = user;
      this.change.search.loading = false;
      this.change.search.q = "";
      this.change.search.results = null;
      this.change.results = null;
      this.change.choosed.id = "";
      this.change.choosed.name = "";
      this.change.choosed.person_number = "";
      this.change.choosed.sponsor.id = "";
      this.change.choosed.sponsor.name = "";
      this.change.choosed.sponsor.person_number = "";
    },
    searchSponsor() {
      if (this.change.search.q.length >= 3) {
        this.change.search.results = null;
        this.change.search.loading = true;

        api
          .post("network/search", {
            name: this.change.search.q,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.change.search.results = response.data.list;
              this.change.search.loading = false;
            } else {
              this.$toast.error(response.data.message);
              this.change.search.results = [];
              this.change.search.loading = false;
            }
          })
          .catch(() => {
            this.change.search.results = [];
            this.change.search.loading = false;
          });
      } else {
        this.$toast.error("Digite pelo menos 3 caracteres para buscar o novo patrocinador.");
      }
    },
    chooseSponsor(user) {
      this.change.step = 2;
      this.change.choosed = user;
    },
    changeSponsor() {
      if (this.change.user.id && this.change.choosed.id) {
        this.change.loading = true;

        api
          .post("network/change", {
            user: this.change.user.id,
            sponsor: this.change.choosed.id,
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.$toast.success(response.data.message);
              this.change.modal = false;
              this.change.loading = false;
              this.getList();
            } else {
              this.$toast.error(response.data.message);
              this.change.loading = false;
            }
          })
          .catch(() => {
            this.$toast.error("Erro ao alterar o patrocinador, tente novamente.");
            this.change.loading = false;
          });
      } else {
        this.$toast.error("Erro ao alterar o patrocinador, tente novamente.");
      }
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    'currentPage': function () {
      this.getList();
    },
    'perPage': function () {
      this.currentPage = 1;
      this.getList();
    },
    'plan': function () {
      this.currentPage = 1;
      this.getList();
    },
    'regional': function () {
      this.currentPage = 1;
      this.getList();
    },
    NameFilter() {
      this.currentPage = 1;
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('Equipe') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">total da equipe</h6>
        <h6 class="m-0">{{ this.totalUsers | points }}</h6>
      </div>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Tipo</h6>
              <div v-if="plan == 'all'">Todos</div>
              <div v-else-if="plan == 'regional'">Regionais</div>
              <div v-else-if="plan == 'consultor'">Consultores</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="plan" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="plan" value="regional">Regionais</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="plan" value="consultor">Consultores</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">Equipe</h6>
              <div v-if="regional == 'all'">Toda rede</div>
              <div v-else-if="regional == 'team'">Minha regional</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="regional" value="all">Toda rede</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="regional" value="team">Minha regional</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h6 class="m-0 text-secondary">itens por página</h6>
              <div>{{ perPage }} itens</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="perPage" value="10">10 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="25">25 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="50">50 itens</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="perPage" value="100">100 itens</b-form-radio></b-dropdown-form>
      </b-dropdown>
    </div>
    <div class="filter-bar d-flex mb-4">
      <div class="totals">
        <h6 class="m-0 text-secondary">Filtrar Por Nome</h6>
      </div>
      <input v-model="NameFilter" type="text" class="form-control search" id="nameFilter" aria-label="Nome do consultor ou da Regional" placeholder="Nome do consultor ou da Regional" />
    </div>
    
    <div class="card">
      <div class="card-body min-vh-25">
        <div class="error text-center min-vh-25" v-if="errored">
          Pedimos desculpas, não podemos recuperar informações neste momento. Por favor, tente novamente mais tarde.
        </div>
        <vcl-list v-else-if="loading" class="col-md-6"></vcl-list>
        <div v-else-if="items && items.length == 0" class="empty text-center min-vh-25 d-flex align-items-center justify-content-center">
          <strong>Nenhum registro encontrado.</strong>
        </div>
        <div v-else class="table-responsive">
          <div class="d-none" style="gap: 15px;">
            <div>
              <b-form-select v-model="filterOn" :options="filterOptions"></b-form-select>
            </div>
            <div class="flex-fill">
              <b-input v-model="filterBy" placeholder="Busca" class="mb-4"></b-input>
            </div>
          </div>
          <b-table stacked="md" :items="items" :fields="fields" class="table-nowrap table-style table-hover min-vh-25" head-variant="light" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filterBy"
            :filter-included-fields="filterOn" responsive>
            <template #cell(avatar)="row">
              <img v-if="row.item.avatar" class="rounded-circle header-profile-user" :src="row.item.avatar" alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" :src="'https://ui-avatars.com/api/?background=27416E&color=fff&name=' + row.item.name" alt="" style="width: 40px; height: 40px" />
            </template>
            <template #cell(name)="row">
              {{ row.item.name }}<br>
              {{ row.item.person_number }}
            </template>
            <template #cell(sponsor)="row">
              {{ row.item.sponsor.name }}<br>
              {{ row.item.sponsor.person_number }}
            </template>
            <template #cell(package)="row">
              <span class="badge badge-soft-dark font-size-12">{{
                row.item.package
                }}</span>
            </template>
            <template #cell(apvs)="row">
              {{ row.item.apvs.brasil.date_last_contract }}
            </template>
            <template #cell(graduation)="row">
              <img v-if="row.item.graduation.image" class="rounded-circle header-profile-user" :src="require('@/assets/images/graduations/' + row.item.graduation.image)
                " alt="" style="width: 40px; height: 40px" />
              <img v-else class="rounded-circle header-profile-user" src="@/assets/images/logo-icon.png" alt="" style="width: 40px; height: 40px" />
              <span class="badge font-size-12">{{ row.item.graduation.name }}</span>
            </template>
            <template #cell(status)="row">
              <span v-if="row.item.status === 'Pending'" class="badge badge-soft-warning p-2 font-size-12 font-weight-bold text-uppercase">{{ t(row.item.status) }}</span>
              <span v-else-if="row.item.status === 'Approved'" class="badge badge-soft-success p-2 font-size-12 font-weight-bold text-uppercase">{{ t(row.item.status) }}</span>
            </template>
            <template #cell(action)="row">
              <button class="btn btn-sm btn-default text-uppercase" v-on:click="showSponsor(row.item)" :disabled="row.item.in_regional == 'yes' || row.item.sponsor_status !== 'released'">
                Alterar
              </button>
            </template>
          </b-table>
        </div>
        <b-pagination v-if="totalUsers > 0" class="m-0 mt-3" v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" pills align="center"></b-pagination>
      </div>
    </div>

    <b-modal v-model="change.modal" title="Alterar patrocinador" modal-class="modal-right" hide-footer>
      <fieldset>
        <legend class="font-size-14 text-uppercase">Usuário</legend>
        <h5 class="mb-0">{{ change.user.name }}</h5>
        <p class="mb-0">{{ change.user.person_number }}</p>
      </fieldset>
      <fieldset>
        <legend class="font-size-14 text-uppercase">Patrocinador Atual</legend>
        <h5 class="mb-0">{{ change.user.sponsor.name }}</h5>
        <p class="mb-0">{{ change.user.sponsor.person_number }}</p>
      </fieldset>
      <template v-if="change.step == 1">
        <b-form-group label="Busque o novo patrocinador" label-for="change.search.q">
          <b-form-input v-model="change.search.q" type="text" autocomplete="off"></b-form-input>
        </b-form-group>
        <b-button class="mb-0 btn-lg btn-block" :disabled="this.change.search.loading" type="submit" variant="default" v-on:click="searchSponsor">
          Buscar
          <b-spinner v-if="change.search.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>

        <fieldset v-if="!change.search.results && change.search.loading == true" class="search-results mt-4">
          <legend class="font-size-14 text-uppercase">Resultados</legend>
          <div class="text-center">
            <b-spinner variant="default" role="status"></b-spinner>
          </div>
        </fieldset>

        <fieldset v-else-if="change.search.results && change.search.results.length == 0 && change.search.loading == false" class="search-results mt-4">
          <legend class="font-size-14 text-uppercase">Resultados</legend>
          <div class="text-center">
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum usuário encontrado
          </div>
        </fieldset>

        <fieldset v-else-if="change.search.results" class="search-results mt-4">
          <legend class="font-size-14 text-uppercase">Resultados</legend>
          <div v-for="(row, index) in change.search.results" :key="index" class="result" style="line-height: 20px;">
            <div class="d-flex justify-content-between">
              <div>
                {{ row.name }}<br>
                <span class="text-muted">{{ row.person_number }}</span>
              </div>
              <div>
                <button class="btn btn-outline-default p-1 px-3" v-on:click="chooseSponsor(row)">Escolher</button>
              </div>
            </div>
            <hr>
          </div>
        </fieldset>
      </template>
      <template v-else-if="change.step == 2">
        <div class="text-center mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="currentColor" viewBox="0 0 24 24">
            <path d="M15 2 11 7 14 7 14 15 16 15 16 7 19 7 15 2z"></path>
            <path d="M10 9 8 9 8 17 5 17 9 22 13 17 10 17 10 9z"></path>
          </svg>
        </div>
        <fieldset>
          <legend class="font-size-14 text-uppercase">Novo Patrocinador</legend>
          <h5 class="mb-0">{{ change.choosed.name }}</h5>
          <p class="mb-0">{{ change.choosed.person_number }}</p>

          <div class="choosed-sponsor">
            <div class="font-weight-bold text-uppercase">Patrocinador</div>
            <div>{{ change.choosed.sponsor.name }}</div>
            <div>{{ change.choosed.sponsor.person_number }}</div>
          </div>
        </fieldset>
        <div>
          <button class="btn btn-default btn-lg btn-block" :disabled="this.change.loading" v-on:click="changeSponsor();">
            Confirmar Alteração
            <b-spinner v-if="change.search.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </button>
          <button class="btn btn-outline-default btn-block" v-on:click="change.step = 1;">Voltar</button>
        </div>
      </template>
    </b-modal>
  </Layout>
</template>

<style scoped>
.search-results .result:last-of-type hr {
  display: none;
}
.choosed-sponsor {
  border-left: solid 2px var(--st-border);
  margin: 10px 0 0 0;
  padding: 5px 0 5px 10px;
  line-height: 18px;
}
</style>
